import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { authService } from '../services/authService';
import './LoginPage.css'; // Reusing login styles for consistency
import logo from '../assets/logo-lnv.jpeg';

const ResetPasswordPage: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);
    
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            setError('Enlace inválido o incompleto. Asegúrate de copiar el enlace completo desde tu correo.');
        }
    }, [token]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!token) return;

        if (password.length < 6) {
            setError('La contraseña debe tener al menos 6 caracteres.');
            return;
        }

        if (password !== confirmPassword) {
            setError('Las contraseñas no coinciden.');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            await authService.resetPassword(token, password);
            setSuccess(true);
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err: any) {
            setError(err.response?.data?.error || 'Ocurrió un error al restablecer la contraseña.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-card">
                    <div className="login-header">
                        <img src={logo} alt="LNV Logo" className="logo-img" />
                    </div>

                    <div className="login-content">
                        <h2 style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#fff' }}>Nueva Contraseña</h2>
                        
                        {success ? (
                            <div style={{ textAlign: 'center' }}>
                                <div className="success-message" style={{ color: '#bef264', marginBottom: '1rem', backgroundColor: '#1e1e1e', padding: '15px', borderRadius: '5px' }}>
                                    ¡Contraseña actualizada exitosamente!
                                </div>
                                <p style={{ color: '#a3a3a3' }}>Redirigiendo al inicio de sesión...</p>
                            </div>
                        ) : (
                            <form className="login-form" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <input
                                        id="password"
                                        type="password"
                                        placeholder="Nueva contraseña"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        disabled={loading || !token}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <input
                                        id="confirmPassword"
                                        type="password"
                                        placeholder="Confirmar nueva contraseña"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        disabled={loading || !token}
                                        required
                                    />
                                </div>

                                {error && <div className="error-message" style={{ marginBottom: '1rem', color: '#ef4444' }}>{error}</div>}

                                <button
                                    type="submit"
                                    className="login-submit-btn"
                                    disabled={loading || !token}
                                >
                                    {loading ? (
                                        <div className="btn-loading">
                                            <div className="spinner"></div>
                                            <span>Guardando...</span>
                                        </div>
                                    ) : (
                                        'Guardar Contraseña'
                                    )}
                                </button>
                            </form>
                        )}

                        {!success && (
                            <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
                                <a href="/login" style={{ color: 'var(--accent)', fontWeight: 600 }}>
                                    ← Volver al inicio de sesión
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
